// extracted by mini-css-extract-plugin
module.exports = {"absolute":"pin_absolute__ns6ap","center":"pin_center__NMNZx","cover":"pin_cover__1l7c3"};